"use client";
import PageTabs from "@/components/PageTabs";
import { ANALYZE_TABS } from "@/lib/nav-groups";
import { useResultShown } from "@/lib/analysis-busy";
import { Link2, FileText } from "lucide-react";

// The tab bar's analyze mark (a link to paste), not a sparkle.
const ICONS = { "/analyze": Link2, "/analyst": FileText };

export default function AnalyzeTabs({ align = "center" }: { align?: "center" | "start" }) {
  return <PageTabs tabs={ANALYZE_TABS} icons={ICONS} defaultHref="/analyze" align={align} />;
}

/** The pill row over /analyze and /analyst, in the shell they share. It
 *  steps aside while a result is on screen: nothing above the answer
 *  (owner decision 1, 2026-10-29). */
export function AnalyzeTabsRow() {
  const resultShown = useResultShown();
  if (resultShown) return null;
  return (
    <div className="no-print mx-auto max-w-6xl px-4 pt-6 sm:px-6">
      <AnalyzeTabs />
    </div>
  );
}
